import { Box, Flex, Stack, xcss } from '@atlaskit/primitives';
import { BoysenberryAppContext, usePageTitle } from '@dev-agents/boysenberry-utils';
import { useIntl } from 'react-intl-next';

import messages from './messages';
import { BoysenberryPrompt } from './prompt';

const styles = xcss({ height: '100%' });
const contentStyles = xcss({ minWidth: '550px' });

export const BoysenberryDashboard = () => {
	const { formatMessage } = useIntl();
	usePageTitle(formatMessage(messages.dashboardPageTitle));

	return (
		<BoysenberryAppContext>
			<Flex justifyContent="center" alignItems="center" xcss={styles}>
				<Stack space="space.200" xcss={contentStyles}>
					<Box>{formatMessage(messages.dashboardWelcome)}</Box>
					<Box>
						<BoysenberryPrompt />
					</Box>
				</Stack>
			</Flex>
		</BoysenberryAppContext>
	);
};
